module.exports = __webpack_public_path__ + "images/materialFlow.6752d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hoverProducts/materialFlow.png
// module id = MF7o
// module chunks = 19